import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';

// Import page constants
import {
  MAIN_PAGE,
  ADD_MEMBERS,
  PAYMENT,
  MEMBER_DETAIL,
  MEMBER_DELETE,
  PLAN_AND_BILLING,
  PAUSE_FEEDBACK,
  PAUSE_FEEDBACK_SURVEY,
  PAUSE_FEEDBACK_DETAIL,
  PAUSE_FEEDBACK_HELP,
  PAUSE_FEEDBACK_CONFIRM,
  CANCEL_SUBSCRIPTION,
  UNCANCEL_SUBSCRIPTION,
  ANNUAL_SUBSCRIPTION
} from 'constants/AccountPageConstants';

// Define modal page types
const TEAM_MODAL_PAGES = [MAIN_PAGE, ADD_MEMBERS, PAYMENT, MEMBER_DETAIL, MEMBER_DELETE];
const BILLING_MODAL_PAGES = [
  PLAN_AND_BILLING, 
  PAUSE_FEEDBACK, // Legacy - will be removed
  PAUSE_FEEDBACK_SURVEY,
  PAUSE_FEEDBACK_DETAIL,
  PAUSE_FEEDBACK_HELP,
  PAUSE_FEEDBACK_CONFIRM,
  CANCEL_SUBSCRIPTION, 
  UNCANCEL_SUBSCRIPTION, 
  ANNUAL_SUBSCRIPTION
];

const TeamModalContext = createContext(null);

export function TeamModalProvider({ children }) {
  const [page, setPage] = useState(null);

  const showBillingModal = useMemo(() => {
    return !!page && BILLING_MODAL_PAGES.includes(page);
  }, [page]);

  const showTeamModal = useMemo(() => {
    return !!page && TEAM_MODAL_PAGES.includes(page);
  }, [page]);

  const openTeamModal = useCallback((initialPage = MAIN_PAGE) => {
    setPage(initialPage);
  }, []);

  const openBillingModal = useCallback((initialPage = PLAN_AND_BILLING) => {
    setPage(initialPage);
  }, []);

  const closeModal = useCallback(() => {
    setPage(null);
  }, []);

  const navigateToPage = useCallback((newPage) => {
    setPage(newPage);
  }, []);

  const value = {
    // State
    page,
    showBillingModal,
    showTeamModal,
    
    // Actions
    openTeamModal,
    openBillingModal,
    closeModal,
    navigateToPage,
    
    // Page constants for convenience
    PAGES: {
      MAIN_PAGE,
      ADD_MEMBERS,
      PAYMENT,
      MEMBER_DETAIL,
      MEMBER_DELETE,
      PLAN_AND_BILLING,
      PAUSE_FEEDBACK,
      PAUSE_FEEDBACK_SURVEY,
      PAUSE_FEEDBACK_DETAIL,
      PAUSE_FEEDBACK_HELP,
      PAUSE_FEEDBACK_CONFIRM,
      CANCEL_SUBSCRIPTION,
      UNCANCEL_SUBSCRIPTION,
      ANNUAL_SUBSCRIPTION
    }
  };

  return (
    <TeamModalContext.Provider value={value}>
      {children}
    </TeamModalContext.Provider>
  );
}

export function useTeamModal() {
  const context = useContext(TeamModalContext);
  if (!context) {
    throw new Error('useTeamModal must be used within a TeamModalProvider');
  }
  return context;
}